import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  constructor() {
    // Get stored user data from localStorage
    const storedUser = localStorage.getItem('user');
    this.currentUserSubject = new BehaviorSubject<any>(storedUser ? JSON.parse(storedUser) : null);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  // Returns the current user value (used in AuthGuard)
  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  // Check if the user is authenticated
  public isAuthenticated(): boolean {
    return this.currentUserValue !== null;
  }

  // Login method (simulated, replace with API call)
  login(userData: any) {
    localStorage.setItem('user', JSON.stringify(userData));
    this.currentUserSubject.next(userData);
  }

  // Logout method
  logout() {
    localStorage.removeItem('user');
    this.currentUserSubject.next(null);
  }
}
